import { atom } from "jotai";
import useHttp from "../hooks/useHttp";

export const caliberSEOLoadingStatusAtom = atom("idle");
export const caliberSEOAtom = atom(null);

export const fetchCaliberSEOAtom = atom(null, async (get, set, caliber) => {
  set(caliberSEOLoadingStatusAtom, "loading");

  const { getCaliberSEO } = useHttp();

  getCaliberSEO(caliber)
    .then((response) => set(caliberSEOAtom, response.seo))
    .finally(() => set(caliberSEOLoadingStatusAtom, "idle"));
});
